import { all, takeLatest, call, fork, put, select, take } from "redux-saga/effects";
import { messages, success, deleteData } from "../../components/messageBox";
import * as types from "../../constants/actionTypes";
import { setLoader } from "./actions";
import moment from "moment";
import Config from "../../service/Config";
import Endpoint from "../../service/Endpoint";
import { GET, POST, PUT } from "../../service/api";
import { Header } from "../../constants/headers";

const getStateModuleKasir = (state) => state.ModuleKasir;

export function* getListReservasi() {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;
    const _body = {
      id: _id,
    };

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_KASIR_LIST_POST, _body);

    if (response.acknowledge == 1) {
      yield put({ type: types.MODULE_KASIR_LISTDATA_RESERVASI_GET_SUCCESS, value: response.data });
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* getDetailReservasi(params) {
  try {
    yield put(setLoader(true));
    const _body = {
      detail: params.value,
    };

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_KASIR_DETAIL_POST, _body);

    if (response.acknowledge == 1) {
      yield put({ type: types.MODULE_KASIR_DETAIL_RESERVASI_GET_SUCCESS, value: response.data });
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* submitPembayaranPasien(params) {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;
    let stateModuleKasir = yield select(getStateModuleKasir);
    const formState = stateModuleKasir.formPembayaranPasien;
    const stateDataReservasi = stateModuleKasir.formPembayaranPasien.dataReservasi;
    const _body = {
      f_kode_invoice: "",
      f_tgl_invoice: moment().format("YYYY-MM-DD HH:mm:ss"),
      f_status_invoice: 0,
      f_sub_total_biaya: formState.totalBiaya,
      f_jenis_diskon: 0,
      f_jumlah_diskon: 0,
      f_total_biaya: formState.totalBiaya,
      f_id_reservasi: params.value,
      f_id_pasien: stateDataReservasi.f_id_pasien,
      f_id_klinik: _id,
    };

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_KASIR_SUBMIT_PEMBAYARAN_PASIEN, _body, { headers: Header() });
    if (response.acknowledge == 1) {
      yield put(setLoader(false));
      messages("Berhasil", response.message, "success", false, params.history);
    } else {
      messages("Error", response.message, "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(types.MODULE_KASIR_LISTDATA_RESERVASI_GET, getListReservasi),
    takeLatest(types.MODULE_KASIR_DETAIL_RESERVASI_GET, getDetailReservasi),
    takeLatest(types.MODULE_KASIR_SUBMIT_FORM_INVOICE_RESERVASI, submitPembayaranPasien),
  ]);
}
